import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchGlobalUpdatePpis } from '../actions';
import {
  getGlobalPpisUpdates,
  getGlobalPpisWithStatus,
  getIsFetching,
  getIsFetchingGlobal
} from '../selectors';
// import { getIsLocalUser } from '../../loginSystem/selectors';

const useGlobalPpisUpdates = ({} = {}) => {
  const dispatch = useDispatch();
  const isFetching = useSelector(getIsFetching);
  // const updateGlobalPpis = useSelector(getGlobalPpisUpdates);
  const updateGlobalPpis = useSelector(getGlobalPpisWithStatus(null));

  // const isLocalUser = useSelector(getIsLocalUser);

  useEffect(() => {
    dispatch(fetchGlobalUpdatePpis());
  }, [dispatch]);

  return [isFetching, updateGlobalPpis];
};

export default useGlobalPpisUpdates;
